export const todosFeatureKey = ['todos'] as const;
